import type { CompanyVersion } from '@festina/legalentity-general-types/legalentity'
import { createRequiredAndOptionalContext } from '@festina-life/ui/libs'

import type { VersionContext } from '../../../../context/VersionProvider'

const [useCompanyVersionContext, useOptionalCompanyVersionContext, provider] =
  createRequiredAndOptionalContext<VersionContext<CompanyVersion>>(
    'CompanyVersion',
  )

export { provider, useCompanyVersionContext, useOptionalCompanyVersionContext }
